import {
	EConfigurationDataFieldNames,
	EOranConfigurationDataFieldNames,
	IConfigurationDataFormValues,
	TConfigurationDataFieldNames,
	TOranConfigurationDataFieldNames,
} from '@interfaces/cmModule/configurationData';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TFileTypes } from '@interfaces/import/import';

import { EFileExtensions, EMenuActionsTypes, EMIMETypes } from '@enums/common';
import {
	EMavenirDataModelType,
	EMavenirDescriptorType,
	EMavenirDeviceType,
	EMavenirElementType,
	EMavenirGroupBy,
	EMavenirPnfType,
} from '@enums/configurationDataModelManagement';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

export const mavenirDescriptorTypeOptions: TSelectOption[] = [
	{ value: EMavenirDescriptorType.modelWithoutDescriptor, label: 'modelWithoutDescriptor' },
	{ value: EMavenirDescriptorType.modelForContainer, label: 'modelForContainer' },
	{ value: EMavenirDescriptorType.modelForVnfc, label: 'modelForVnfc' },
];

export const mavenirDataModelTypeOptions: TSelectOption[] = [
	{ value: EMavenirDataModelType.modelWithSchema, label: 'modelWithSchema' },
	{ value: EMavenirDataModelType.modelWithExistingSchema, label: 'modelWithExistingSchema' },
	{ value: EMavenirDataModelType.modelWithoutSchema, label: 'modelWithoutSchema' },
];

export const mavenirDeviceTypeOptions: TSelectOption[] = [
	{ value: EMavenirDeviceType.Pnf, label: 'Pnf' },
	{ value: EMavenirDeviceType.Cnf, label: 'Cnf' },
	{ value: EMavenirDeviceType.Vnfc, label: 'VNFC' },
];

export const mavenirPnfTypeOptions: TSelectOption[] = [
	{ value: EMavenirPnfType.DU, label: 'DU' },
	{ value: EMavenirPnfType.RRU, label: 'RRU' },
	{ value: EMavenirPnfType.A2, label: 'A2' },
	{ value: EMavenirPnfType.EUS, label: 'EUS' },
];

export const mavenirElementTypeOptions: TSelectOption[] = [
	{ value: EMavenirElementType.NF, label: 'NF' },
	{ value: EMavenirElementType.NFService, label: 'NF_SERVICE' },
];

export const mavenirGroupByOptions: TSelectOption[] = [
	{ value: EMavenirGroupBy.LABEL, label: 'LABEL' },
	{ value: EMavenirGroupBy.TYPE, label: 'TYPE' },
];

export const configurationDataFormLabels: Record<TConfigurationDataFieldNames, string> = {
	[EConfigurationDataFieldNames.NAME]: 'Name',
	[EConfigurationDataFieldNames.DESCRIPTOR_TYPE]: 'Descriptor Type',
	[EConfigurationDataFieldNames.DATA_MODEL_TYPE]: 'Data Model Type',
	[EConfigurationDataFieldNames.DEVICE_TYPE]: 'Device Type',
	[EConfigurationDataFieldNames.VDU_ID]: 'Vdu id',
	[EConfigurationDataFieldNames.DATA_MODEL]: 'Data Model',
	[EConfigurationDataFieldNames.PNF_TYPE]: 'Pnf Type',
	[EConfigurationDataFieldNames.BUILD_VERSION]: 'Build Version',
	[EConfigurationDataFieldNames.ELEMENT_TYPE]: 'Element Type',
	[EConfigurationDataFieldNames.GROUP_BY]: 'Group By',
	[EConfigurationDataFieldNames.PRODUCT_NAME]: 'Product Name',
	[EConfigurationDataFieldNames.NS_ID]: 'Ns id',
	[EConfigurationDataFieldNames.NS_VERSION]: 'Ns Version',
	[EConfigurationDataFieldNames.NF_TYPE]: 'Nf Type',
	[EConfigurationDataFieldNames.COMPONENT_TYPE]: 'Component Type',
	[EConfigurationDataFieldNames.COMPONENT_VERSION]: 'Component Version',
};

export const configurationOranDataFormLabels: Record<TOranConfigurationDataFieldNames, string> = {
	[EOranConfigurationDataFieldNames.NAME]: 'YANG Model Collection Name',
};

export const configurationDataFormDefaultRequiredFields: Array<keyof IConfigurationDataFormValues> = [
	EConfigurationDataFieldNames.NAME,
	EConfigurationDataFieldNames.DESCRIPTOR_TYPE,
	EConfigurationDataFieldNames.DATA_MODEL_TYPE,
	EConfigurationDataFieldNames.DEVICE_TYPE,
];

export const acceptedFileTypesSchema: TFileTypes = {
	[EMIMETypes.zip]: [EFileExtensions.zip],
};

export const acceptedFileTypesYangSchema: TFileTypes = {
	[EMIMETypes.yang]: [EFileExtensions.yang],
};

export const MAX_FILES_SCHEMA = 1;

export const fileErrorsSchema = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: ZIP.',
	[EDropzoneFileErrorCodes.tooManyFiles]: 'Only one file can be uploaded',
};

export const fileErrorsYangSchema = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: YANG.',
	[EDropzoneFileErrorCodes.tooManyFiles]: 'A maximum of 20 files can be uploaded at once.',
};

export const menuActionsSchema = [
	{
		text: 'Selected on current page',
		id: EMenuActionsTypes.selected,
		disabled: false,
	},
	{
		text: 'Current page',
		id: EMenuActionsTypes.currentPage,
		disabled: false,
	},
	{
		text: 'All',
		id: EMenuActionsTypes.all,
		disabled: false,
	},
];
